import React from 'react';

// Bold heading on the left, body copy on the right — the reading rhythm used
// by the MoSAIC PSYOPS results and The Day After pages.
const SplitSection = ({ heading, paragraphs = [], children, className = 'mt-12' }) => (
  <div className={`flex flex-col md:flex-row gap-6 md:gap-10 ${className}`}>
    <h2 className="md:w-1/3 flex-shrink-0 text-2xl xl:text-3xl font-bold text-black">{heading}</h2>
    <div className="md:flex-1 space-y-4">
      {paragraphs.map((text, i) => (
        <p key={i} className="text-black leading-relaxed">{text}</p>
      ))}
      {children}
    </div>
  </div>
);

export default SplitSection;
